import { Injectable } from '@angular/core';
declare var toastr: any;

@Injectable({ providedIn: 'root' })
export class ToasterService {

  constructor() { }

  showToaster(message){
    return toastr.error(message);
  }

  showWarningToaster(msg) {
    return toastr.warning(msg);

  }

}
